import { get } from "../../service/api";

const getInvoiceData = async (secureId) => {
  try {
    const response = await get(`/invoice/bySecureId/${secureId}`);
    if (!response) return null;

    if (response.spayToken)
      localStorage.setItem("merchantToken", response.spayToken);
    if (response.smaToken) localStorage.setItem("smaToken", response.smaToken);

    return response.data;
  } catch (error) {
    alert("Error fetching invoice data:", error);
    throw error;
  }
};

export default getInvoiceData;
